import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { LangSwitcher } from "./LangSwitcher";

export function Nav() {
  const { t } = useI18n();
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[var(--color-cream)]/70 border-b border-black/5">
      <div className="max-w-[1440px] mx-auto px-8 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <span className="w-7 h-7 rounded-full bg-[var(--color-forest-deep)] block" />
          <span className="font-logo text-[15px] text-[var(--color-forest-deep)]">ALVION</span>
        </Link>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          <Link to="/waitlist" className="pill-btn !py-2 !px-5 text-sm">{t("nav.join")}</Link>
        </div>
      </div>
    </header>
  );
}
